import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React from "react";
import Box from "../../../Box";
import Flex from "../../../Flex";
import Typography from "../../../Typography";
import useAuditTrail from "../../hooks/useAuditTrail";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function AuditItem(_ref) {
  var item = _ref.item;
  var _useAuditTrail = useAuditTrail(item),
    _useAuditTrail2 = _slicedToArray(_useAuditTrail, 3),
    time = _useAuditTrail2[0],
    auditHistory = _useAuditTrail2[1],
    AvatarComponent = _useAuditTrail2[2];
  return /*#__PURE__*/_jsxs(Flex, {
    direction: "row",
    align: "start",
    wrap: "noWrap",
    children: [/*#__PURE__*/_jsx(AvatarComponent, {}), /*#__PURE__*/_jsx(Box, {
      pt: "xs",
      children: /*#__PURE__*/_jsxs(Flex, {
        spacing: "xs",
        direction: "row",
        wrap: "wrap",
        children: [/*#__PURE__*/_jsx(Typography, {
          children: auditHistory
        }), /*#__PURE__*/_jsx(Typography, {
          children: item.dateTime && !time.invalidTime && " on ".concat(time.date, " at ").concat(time.time, " (").concat(time.humanTime, ") ")
        })]
      })
    })]
  });
}
export default AuditItem;